import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../remote/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authtoken = inject(AuthService).getTokenFromLocalStorage();
  const router = inject(Router);
  if (!authtoken) {
    router.navigate(['/login']);
    return false;
  }
  return true;
};
